import React, {useEffect, useMemo, useState} from 'react';
import {Plan} from '../types/Plan';
import {EnumPlanObdobi, PlanVO, StromApi} from '../api';
import {Col, Dropdown, Row, Spinner} from 'react-bootstrap';
import {TreeView} from './TreeView';
import {PRUBEH} from '../enums/PohledTypeEnum';
import {MEZIROCNI_PRUBEH, MEZIROCNI_SROVNANI, PODPOLOZKY} from '../enums/ChartTypeEnum';
import {useHistory} from 'react-router';
import {BaseChart} from './BaseChart';
import {StromDetail} from './StromDetail';
import {PolozkaDetail} from './PolozkaDetail';

interface StromPanelProps {
    skutecnost: boolean;
    idPlan: string;
    idVerze: string;
}

export const StromPanel: React.FC<StromPanelProps> = ({skutecnost, idPlan, idVerze}) => {
    const history = useHistory();

    const [plans, setPlans] = useState<Plan[]>([]);
    const [fetching, setFetching] = useState<boolean>(false);
    const [chartType, setChartType] = useState<string>(PODPOLOZKY);

    const selectedPlan = useMemo(() => {
        if (plans) {
            if (idPlan) {
                return plans.find(item => item.idPlan === parseInt(idPlan));
            } else {
                return plans[0];
            }
        } else {
            return undefined;
        }
    }, [idPlan, plans]);

    let chartTypes =
        selectedPlan?.subItemsCount === null ? [MEZIROCNI_SROVNANI, PRUBEH, MEZIROCNI_PRUBEH] : [PODPOLOZKY, MEZIROCNI_SROVNANI, PRUBEH, MEZIROCNI_PRUBEH];

    useEffect(() => {
        loadPlans();
    }, [idVerze]);

    useEffect(() => {
        if (selectedPlan && selectedPlan.subItemsCount === null && chartType === PODPOLOZKY) {
            setChartType(PRUBEH);
        }
    }, [selectedPlan, chartType]);

    const loadPlans = () => {
        const fetchData = async () => {
            let data: PlanVO[] = [];
            try {
                setFetching(true);
                data = (await StromApi.getZaznamy(parseInt(idVerze), EnumPlanObdobi.PLAN, undefined)).data;
                // @ts-ignore
                const plns: Plan[] = data.map(item => {
                    return {...item, collapsed: true, shown: item.uroven === 1};
                });
                setPlans(plns);
                setFetching(false);
            } catch (error) {
                // TODO
            }
        };
        fetchData();
    };

    const changeSelected = (plan: Plan) => {
        history.replace(`/strom/${idVerze}/${plan.idPlan}`);
    };

    const changeChartType = (chartType: string) => {
        setChartType(chartType);
    };

    if (fetching) {
        return (
            <div className="loading-data">
                <Spinner animation="border" role="status" style={{marginRight: 10}} />
                Načítání dat...
            </div>
        );
    }

    const planObdobi: EnumPlanObdobi = skutecnost ? EnumPlanObdobi.SKUTECNOST : EnumPlanObdobi.PLAN;

    return (
        <Row>
            <Col xxl={6} lg={12}>
                <TreeView data={plans} skutecnost={skutecnost} setSelected={changeSelected} idPlan={idPlan ? parseInt(idPlan) : undefined} />
            </Col>
            {selectedPlan && chartType && (
                <Col xxl={6} lg={12}>
                    <StromDetail plan={selectedPlan} skutecnost={skutecnost} />
                    <Dropdown style={{paddingTop: 5, paddingBottom: 20}}>
                        <Dropdown.Toggle variant="light" id="dropdown-basic">
                            {chartType}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {chartTypes.map(item => {
                                return (
                                    <Dropdown.Item key={item} onClick={() => changeChartType(item)}>
                                        {item}
                                    </Dropdown.Item>
                                );
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                    <div className="centered">
                        <BaseChart chartType={chartType} plans={plans} selectedPlan={selectedPlan} planObdobi={planObdobi} idVerze={idVerze} />
                    </div>
                    <PolozkaDetail plan={selectedPlan} />
                </Col>
            )}
        </Row>
    );
};
